/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/discussion',
  name: 'Discussion',
  component: () => import('@/views/discussion/Index'),



}]
